import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { getCurrentJSTString } from '../../services/UtilityService';
import { ProductPrintableContent } from './ProductPrintableContent';
import { formatDateTime, padNumber } from '../../services/UtilityService';

const PrintInstockList = forwardRef(({ printData }, ref) => {
  const hiddenRef = useRef();
  const printDate = getCurrentJSTString();
  const printableTitle = `${printData?.printHeader || ""}-${printDate}`;

  const specificInfoElement = (
    <></>
  )

  const handlePrint = () => {
    const printWindow = window.open('', '_blank', 'width=600,height=800');
    if (!printWindow) return;

    const content = hiddenRef.current.innerHTML;

    // find all stylesheet links in the parent document
    const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
      .map(node => node.outerHTML)
      .join('\n');

    const fullHtml = `
<html>
<head>
  <title>${printableTitle}</title>
  ${styles}   <!-- this injects bootstrap and other styles from your app -->
  <style>
    @page { margin: 5mm 25mm; }
    body {
      font-family: monospace;
      font-size: 12px;
      padding: 5mm;
      box-sizing: border-box;
      background: #fff;
    }
    .productPrintContent {
      word-break: break-word;
      border: 1px solid #ccc;
      padding: 5mm;
      width: 600px;
      margin: 0 auto;
    }
    table {
      min-width: 350px;
      max-width: fit-content;
      margin: 0 auto;
      border-collapse: collapse;
    }
    td {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    /* ⬇️ Prevent rows from splitting across pages */
    .no-break-print {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        display: table-row-group; /* ensure tbody keeps table semantics */
    }
    hr { border: none; border-top: 1px solid #ccc; }
  </style>
</head>
<body>
  ${content}
  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function () { window.close(); };
    }
  </script>
</body>
</html>
`;


    printWindow.document.open();
    printWindow.document.write(fullHtml);
    printWindow.document.close();
  };


  // 👇 Expose handlePrint to parent
  useImperativeHandle(ref, () => ({
    handlePrint
  }));

  return (
    <div
      ref={hiddenRef}
      style={{
        position: 'absolute',
        bottom: 0,
        left: '-9999px',
        width: '600px',
        background: 'white',
        color: 'black',
        padding: '10px',
      }}
    >
      <ProductPrintableContent printData={printData} specificInfoElement={specificInfoElement} />
    </div>
  );
});

export default PrintInstockList;